'use client';
import Link from 'next/link';
import type { FunctionComponent } from 'react';
import { useAppContext } from '@/modules/app-context/use-app-context';
import { getAppURL } from '@/modules/utils/env';
import { Button } from '@/ui-components/button/button';
import { Flexbox } from '@/ui-components/flexbox/flexbox';
import { useAuth, useTranslations } from '@power-core/toolkit';

export const AuthButtonGroup: FunctionComponent = () => {
	const t = useTranslations();
	const { isLoading, setIsLoading } = useAppContext();
	const { signIn } = useAuth();

	const handleSignIn = async () => {
		setIsLoading(true);
		signIn(await getAppURL());
	};

	return (
		<Flexbox justify='center' className='gap-3 min-w-32' wrap='wrap'>
			<div className='min-w-32'>
				<Button variant='ghost-secondary' disabled={isLoading} isLoading={isLoading} onClick={handleSignIn}>
					{t('T_SIGN_IN')}
				</Button>
			</div>
			<div className='min-w-32'>
				<Link href={`https://usermanagement.abb.com/account/Register?lang=en-GB&returnUrl=${window.location.origin}`}>
					<Button variant='primary' disabled={isLoading}>
						{t('T_SIGN_UP')}
					</Button>
				</Link>
			</div>
		</Flexbox>
	);
};
